<template>
  <div>
    <div v-if="loading" class="lds-ring-grey">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    <canvas id="line-chart" width="400" height="200" :class="{ hidden: loading }"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js/auto';

export default {
  props: {
    alertData: {
      type: Array,
    },

    monitoringData: {
      type: Array,
    },

    labels: {
      type: Array,
    },
  },

  data() {
    return {
      context: null,
      chart: null,
      loading: true,
    };
  },

  watch: {
    monitoringData(data) {
      if (this.chart) {
        this.chart.data.datasets[0].data = data;
        this.chart.update();
      }
    },

    alertData(data) {
      if (this.chart) {
        this.chart.data.datasets[1].data = data;
        this.chart.update();
      }
    },

    labels(labels) {
      if (this.chart) {
        this.loading = true;
        this.chart.data.labels = labels;
        this.chart.update();
        setTimeout(() => {
          this.loading = false;
        }, 1000);
      }
    },
  },

  mounted() {
    this.initChart();
  },

  methods: {
    initChart() {
      this.context = document.getElementById('line-chart').getContext('2d');
      this.chart = new Chart(this.context, {
        type: 'line',
        options: {
          responsive: true,
          tooltips: {
            intersect: true,
            mode: 'point',
            cornerRadius: 6,
            displayColors: false,
            bodyAlign: 'center',
            titleAlign: 'center',
            backgroundColor: 'rgba(55,67,83, 0.8)',
          },
          legend: {
            display: false,
          },
        },
        data: {
          labels: this.labels,
          datasets: [
            {
              label: this.$t('totalMonitoring'),
              data: this.monitoringData,
              borderColor: '#1C236B',
              backgroundColor: '#1C236B',
              pointRadius: 0,
              pointHitRadius: 5,
              pointHoverRadius: 10,
              pointHoverBorderWidth: 2,
              lineTension: 0.4,
              pointHoverBorderColor: '#FFF',
              pointHoverBackgroundColor: '#1C236B',
            },
            {
              label: this.$t('alertCount'),
              data: this.alertData,
              borderColor: '#1C7AC6',
              backgroundColor: '#1C7AC6',
              pointRadius: 0,
              pointHoverRadius: 10,
              pointHoverBorderWidth: 2,
              pointHitRadius: 5,
              lineTension: 0.4,
              pointHoverBorderColor: '#FFF',
              pointHoverBackgroundColor: '#1C7AC6',
            },
          ],
        },
      });
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';
canvas.hidden {
  opacity: 0;
  height: 0;
}
</style>
